import React from 'react';

// Démarchage à domicile : une seule ligne, sans réglage. Le dossier est marqué automatiquement quand le client signe sur
// place (« Faire signer sur place »), et le serveur applique seul les délais légaux (functions/api/modules/demarchage.js).
// Le vendeur n'a rien à régler ni à comprendre : il voit seulement à partir de quand il peut fixer le rendez-vous.

interface Regle {
    signe_le: string | null;
    paiement_possible_le: string | null;
    intervention_possible_le: string | null;
    fin_retractation: string | null;
    paiement_bloque: boolean;
    execution_anticipee: boolean;
}

const jour = (j: string | null | undefined) => (j ? new Date(`${j}T12:00:00`).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' }) : '');

export function DemarchageDomicile({ dossier }: { dossier: any; onChange?: () => void }) {
    const regle: Regle | null = dossier.demarchage || null;
    if (Number(dossier.hors_etablissement) !== 1 || !regle?.intervention_possible_le) return null;
    return (
        <p className="text-xs text-content-muted rounded-xl bg-surface-soft border border-border px-3.5 py-2.5">
            Premier rendez-vous possible à partir du <span className="font-bold text-content">{jour(regle.intervention_possible_le)}</span>
            {regle.fin_retractation ? <> · le client peut se rétracter jusqu'au {jour(regle.fin_retractation)}</> : null}
            {regle.paiement_bloque && regle.paiement_possible_le ? <> · aucun paiement avant le {jour(regle.paiement_possible_le)}</> : null}.
        </p>
    );
}
